export default {
  storeType: {
    StoreTypeName: 'StoreType Name',
    orderDiscount: 'Order Discount',
    remark: 'Remark',
    createUserId: 'Create UserId',
    createUserName: 'Create UserName',
    createTime: 'Create Time',
    modifyUserId: 'Modify UserId',
    modifyUserName: 'Modify UserName',
    modifyTime: 'Modify Time',
    addStoreType: 'Add StoreType'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/cmc/storeType.js